import React, { Component } from 'react';
import Classnames from 'classnames';
import { select, drag, event } from 'd3';

import './style.css'

export default class Weighting extends Component {
  state = {
    dragging: false,
  };

  constructor(props) {
    super(props);
    this.dragThumb = this.dragThumb.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
  }

  updateValue(x, modifier, method) {
    const { scale, onChange } = this.props;
    let value = scale.invert(event.x);
    const domain = scale.domain();
    value = Math.min(domain[1], Math.max(domain[0], value));
    // if (modifier) value = Math.round(value * 100) / 100
    if (onChange != null) onChange(value, method);
  }

  onKeyDown(event) {
    const { onChange, previous } = this.props;
    if (event.keyCode === 27) {
      if (this.state.dragging) {
        if (onChange != null) onChange(previous, 'dragend');
        this.setState({ dragging: false });
      }
    }
  }

  dragThumb(node) {
    if (node != null) {
      select(node).call(
        drag()
          .on('start', () => this.setState({ dragging: true }))
          .on('drag', () => {
            if (this.state.dragging) {
              this.updateValue(
                event.x,
                event.sourceEvent.metaKey,
                'drag'
              );
            }
          })
          .on('end', () => {
            if (this.state.dragging) {
              this.updateValue(
                event.x,
                event.sourceEvent.metaKey,
                'dragend'
              );
              this.setState({ dragging: false });
            }
          })
      );

      window.addEventListener('keydown', this.onKeyDown);
    } else {
      window.removeEventListener('keydown', this.onKeyDown);
    }
  }

  render() {
    const { weighting, scale, unapplicable } = this.props;
    const { onClickBar } = this.props;
    const { dragging } = this.state;

    const width = scale(weighting);
    const maxWidth = scale.range()[1];

    return (
      <div
        className={Classnames('weighting', { unapplicable })}
        style={{ width: maxWidth }}
      >
        <div
          className={Classnames('weighting-bar', {
            dragging,
            zero: width === 0,
          })}
          style={{ width: Math.max(1, width) }}
          onClick={onClickBar}
        >
          <div
            className="weighting-bar-thumb"
            ref={this.dragThumb}
            onClick={event => event.stopPropagation()}
          >
            <div />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Weighting/index.js